import React from 'react';
import styles from './Contact.css';
import zako from '../../assets/pzako.png';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ModuleWrap from "../ModuleWrap/ModuleWrap";

const Contact = (props) => {
    return (
        <div className={styles.desktopStyle}>
            <ModuleWrap title="Kontakt" icon={props.icon}>
                <div className={styles.centerItems}>
                    <p className={styles.address}>
                        <li>Przedsiębiorstwo Żako</li>
                        <li>Tatary 6A</li>
                        <li>34-500 Zakopane</li>
                    </p>
                    <li><FontAwesomeIcon className={styles.iconContact} icon={props.iconPhone}/>602 471 040</li>
                    <li className={styles.mail}><FontAwesomeIcon className={styles.iconContact} icon={props.iconMail}/><img src={zako} alt="zako"/></li>
                </div>
            </ModuleWrap>
        </div>
    )
};

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js